import gsap from "gsap";

export default function productHover() {
  const product = document.querySelector("section.products");
  const isMobile = window.innerWidth <= 1024;
  if (!product || isMobile) return;
  const products = product.querySelectorAll(".product");

  products.forEach((product) => {
    let desc = product.querySelector(".description");

    let tl = gsap.timeline({ paused: true });

    tl.to(desc, {
      duration: 0.3,
      autoAlpha: 0,
      height: 0,
      ease: "none",
    });

    const pl = () => {
      tl.play();
    };
    const rv = () => {
      tl.reverse();
    };

    pl();
    product.addEventListener("mouseenter", rv);
    product.addEventListener("mouseleave", pl);
  });
}
